import { get } from "lodash-es";

export function formatAmountInr(amount) {
  if (!amount) {
    if (amount === 0) {
      return "₹" + amount;
    } else {
      return "₹";
    }
  }

  const isNegativeVal = amount < 0;
  amount = Number(amount);
  amount = amount.toFixed(0);
  amount = Math.abs(amount);
  amount = amount.toString();
  let lastThree = amount.substring(amount.length - 3);
  let otherNumbers = amount.substring(0, amount.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  res = "₹" + res;
  if (isNegativeVal) {
    res = "-" + res;
  }
  return res
}

export const convertInrAmountToNumber = (value) => {
  let amount = (value.match(/\d+/g) || "").toString();
  if (amount) {
    amount = amount.split(",").join("");
  }
  return parseInt(amount, 10);
};

export const getUserName = (kyc) => {
  return get(kyc, "pan.meta_data.name", "");
};

export const capitalizeName = (name) => {
  if (!name) {
    return "";
  }

  const words = name.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
  }

  return words.join(" ");
};

export const inrFormatDecimal = (number, toFixed) => {
  const isNegative = number < 0;
  number = Math.abs(number);
  if (number || number === 0) {
    number = parseFloat(number);
    number = number.toFixed(toFixed || 0);
    number = number.toString();
    var afterPoint = "";
    if (number.indexOf(".") > 0)
      afterPoint = number.substring(number.indexOf("."), number.length);
    number = Math.floor(number);
    number = number.toString();
    var lastThree = number.substring(number.length - 3);
    var otherNumbers = number.substring(0, number.length - 3);
    if (otherNumbers !== "") lastThree = "," + lastThree;
    var res =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
      return `${isNegative ? '-₹' : '₹'}${res}`;
    } else {
    return "₹";
  }
};

export const numDifferentiationWithNoSpace = (
  value,
  withSymbol=true,
  decimalPlaces = 2,
  retainLeadingZeroes = false,
  shortenPlaceText=true
) => {
  if (!value) {
    value = "";
  }

  const isNegativeVal = value < 0;

  function postFix(val) {
    return parseFloat(val) < 2;
  }

  let val = Math.abs(value);

  if (val < 1000) {
    return inrFormatDecimal(value);
  } else if (val >= 10000000) {
    val = (val / 10000000).toFixed(decimalPlaces);
    const isPluralVal = postFix(val);
    if (shortenPlaceText) {
      val += "Cr";
    } else {
      val += " Crore" + (isPluralVal ? "" : "s");
    }
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(decimalPlaces);
    const isPluralVal = postFix(val);
    if (shortenPlaceText) {
      val += "L";
    } else {
      val += " Lakh" + (isPluralVal ? "" : "s");
    }
  } else {
    val = (val / 1000).toFixed(decimalPlaces) + "K";
  }

  // remove .00
  if (!retainLeadingZeroes) {
    val = val.toString().replace(/\.0+([^\d])/g, "$1");
  }

  if (withSymbol) {
    val = "₹" + val;
  }

  if (isNegativeVal) {
    val = "-" + val;
  }
  return val;
};

export const dateOrdinal = (dom) => {
  if (dom === 31 || dom === 21 || dom === 1) return dom + "st";
  else if (dom === 22 || dom === 2) return dom + "nd";
  else if (dom === 23 || dom === 3) return dom + "rd";
  else return dom + "th";
};

export function buildUrlWithQueryParams(uri, params = {}) {
  let newUrl = uri;
  let separator = uri.includes('?') ? '&' : '?';

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      newUrl += (separator + key + '=' + value);
      if (separator === '?') separator = '&';
    }
  })

  return newUrl;
}

export const splitMobileNumber = (value = "") => {
  if (!value) return {};

  if (value.includes("|")) {
    const [countryCode, number] = value.split('|');
    return { countryCode, number };
  } else {
    const number = value.slice(-10);
    const countryCode = value.slice(0, -10);
    return { countryCode, number };
  }
};